module.exports = __webpack_public_path__ + "3a535f5d0491f15817d109dc8dc06581.pdf";